// DO NOT EDIT -- generated from Go package fs/api/clientapi

import * as orgsproto from '@fullstory/proto/fs/services/orgs';
import * as fsta from './fs_featureflags_fsta';
import * as locale from './fs_locale';
import * as model from './fs_model';
import * as privacy from './fs_shared_privacy';
import * as sharedapi from './fs_shared_sharedapi';
import * as time from './time';


///////////
// Enums //
///////////

export enum UtmParam {
	UtmCampaign = "utm_campaign",
	UtmContent = "utm_content",
	UtmMedium = "utm_medium",
	UtmTerm = "utm_term",
	UtmSource = "utm_source",
	UtmOffer = "utm_offer"
}

export enum GrantRequestStatus {
	Success = "success",
	Missing = "missing",
	OutOfSeats = "outOfSeats",
	SeatNotFound = "seatNotFound",
	SeatExists = "seatExists",
	InviteExists = "inviteExists",
	ErrorOther = "error"
}

export enum UserExportKind {
	ExportUserEvents = 0,
	ExportUserPages = 1
}

export enum LoginFlag {
	Unknown = 0,
	NativeMobileAdEnabled = 1
}


///////////////
// Constants //
///////////////

export const InactivityTimeoutSettingsEndpoint: string = "/settings/inactivityTimeout";
export const SetInactivityTimeoutSettingsEndpoint: string = "/settings/setInactivityTimeout";
export const MaxStoryName: number = 5e+02;
export const MaxStoryDescription: number = 1e+04;

/////////////
// Structs //
/////////////

// view of model.SeatSettings
export interface SeatSettings {
  DigestFreq: model.Frequency;
  QuotaEmailEnabled: boolean;
  WebhookNotificationsEnabled: boolean;
  FollowedSegments: string[] | null;
  MentionEmailsEnabled: boolean;
  OpportunitiesEmailsEnabled: boolean;
  HomeBetaDisabled: boolean;
  DismissedWarnings: model.DismissibleWarning[] | null;
  SpacesEnabled: boolean;
}

// Seat-level settings for Annotations in FSTA
export interface AnnotationsSettings {
  HideAnnotations: boolean;
}

// This config is only used to initialize the LD JS SDK running in the browser.
// The JS SDK is used only for collecting experimentation from the app events
// for LD experiments, it is not used for regular feature flag evaluation.
export interface LaunchDarklyConfig {
  ClientSideId: string;
  UserKey: string;
  UserHash: string;
}

export interface GeoZone {
  Code: string;
  Name: string;
  Countries: string[] | null;
  Type: locale.ZoneType;
}

export interface UiBootstrap {
  APIHost: string;
  FrontendHost: string;
  Email: string;
  OrgId: string;
  UmbrellaId: string;
  FirstName: string;
  LastName: string;
  Personas: string[] | null;
  JTBD: string;
  Industry: string;
  OrgName: string;
  SeatRole: orgsproto.Role;
  SsoRoleMapping: boolean;
  AppearanceMode: orgsproto.AppearanceMode;
  SeatSettings: SeatSettings | null;
  OrgLevel0: model.OrgLevel0 | null;
  Level0: model.Level0 | null;
  SearchTipsHidden: boolean;
  AnnotationsSettings: AnnotationsSettings | null;
  AvailGeoZones: Array<GeoZone | null> | null;
  HiddenCustomVars: string[] | null;
  Debug: string;
  MapsApiKey: string;
  GtmApiKey: string;
  GoogleClientId: string;
  Flags: {[key: string]: number} | null;
  OverriddenFlags: {[key: string]: number} | null;
  FeatureFlags: fsta.FstaFlags | null;
  PrivacyFlags: privacy.PrivacyFlags | null;
  TrialExpiration: number;
  Snippet: string;
  BasePlan: orgsproto.BasePlan;
  PlanStage: orgsproto.PlanStage;
  SeatCreated: number;
  OrgCreated: number;
  FirstRecordDate: number;
  NotificationsLastSeen: number;
  ShareSessionEnabled: boolean;
  CurrentTermsVersion: number;
  InactivityTimeout: number;
  OrgUseWeeklyEveryone: boolean;
  RetentionTimestamp: number;
  PlaybackRetentionTimestamp: number;
  PrivateByDefault: boolean;
  LaunchDarklyConfig: LaunchDarklyConfig | null;
  CustomSeatRequestConfig: model.CustomSeatRequestConfig | null;
  Platform: orgsproto.Platform;
}

// Org plan attributes needed for Appcues initialization
export interface OrgPlanAttrs {
  StageStr: string;
  PacksStr: string;
  Sessions?: number;
  SessionCount?: string;
  Seats: number;
  History: number;
  BasePlanStr: string;
  CreatedDt: time.Time | null;
  FirstRecordDate: time.Time | null;
}

// Seat attrs needed for Appcues initialization
export interface SeatAttrs {
  CreatedDt: time.Time | null;
  RoleStr: string;
}

// Simplified version of an integration with details client needs
export interface ClientIntegration {
  ServiceId: string;
  Enabled: boolean;
}

export interface OrgProvisionDetails {
  AllowedSeats: number;
  UsedSeats: number;
  UnlimitedSeats: boolean;
}

export interface OrgInfo {
  Id: string;
  Name: string;
  GoogleAuthEnforced: boolean;
  SSOAuthEnforced: boolean;
  SSOIntId: string;
  SSOTeam: string;
  ProvisionDetails: OrgProvisionDetails | null;
}

export interface OrgChooserInfo {
  OrgInfoList: Array<OrgInfo | null> | null;
  HintOrgId: string;
  BrandingImageUrl: string;
}

// Matches the input names from the form in `signup.main.jsx`
export interface SignupRequest {
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  phone: string;
  coupon: string;
  captcha: string;
  freemium: boolean;
  opt_in: boolean;
  utm_parameters: {[key: string]: string} | null;
  captcha_token: string;
  country: string;
  platform: orgsproto.Platform;
}

export interface SignupResponse {
  RedirectUrl: string;
}

export interface SignupPageParams {
  RecaptchaSiteKey: string;
}

export interface RoleUpdate {
  OrgId: string;
  Role: orgsproto.Role;
  Delete: boolean;
}

// TODO(sarahgrace): Update to use orgs.Role
export interface RoleChangeReq {
  Role: string;
  SeatRole: orgsproto.Role;
}

export interface JoinOrgVerificationReq {
  Email: string;
  FirstName: string;
  LastName: string;
  OrgId: string;
  Justification: string;
}

export interface UmbrellaSeatUpdateReq {
  UmbrellaId: string;
  Email: string;
  Updates: Array<RoleUpdate | null> | null;
}

export interface UpdateUmbrellaMetadataReq {
  UmbrellaId: string;
  Name: string;
}

export interface UpdateUmbrellaOrgReq {
  OrgId: string;
  Sessions?: number | null;
  SessionCount?: string;
}

export interface CreateUmbrellaOrgReq {
  UmbrellaId: string;
  Name: string;
  Sessions?: number | null;
  SessionCount?: string;
}

export interface CancelUmbrellaOrgsReq {
  UmbrellaId: string;
  OrgIds: string[] | null;
}

export interface UiInvoiceLine {
  Description: string;
  Amount: number;
}

export interface UiInvoice {
  ID: string;
  Date: number;
  Start: number;
  End: number;
  Attempted: boolean;
  Paid: boolean;
  AmountDue: number;
  Total: number;
  CardType: string;
  Last4: string;
  Lines: Array<UiInvoiceLine | null> | null;
}

export interface InvoiceResponse {
  InvoiceName: string;
  InvoiceInfo: string;
  Invoices: Array<UiInvoice | null> | null;
  InvoiceEmail: string;
}

export interface UpdateInvoiceInfoReq {
  InvoiceName: string;
  InvoiceInfo: string;
}

export interface DownloadUserExportRequest {
  Kind: UserExportKind;
  AppId: string;
  UserId: string;
}

// OrgAdminInfo is a subset of the Org model.
export interface OrgAdminInfo {
  OrgId: string;
  Name: string;
  Size: number;
  Domain: string;
  Industry: string;
  BenchmarkingDisabled: boolean;
  IdProviderEnforced: boolean;
}

export interface InactivityTimeoutSettings {
  UserInactivityTimeout: number;
  AdminInactivityTimeout: number;
}

export interface SSOLoginInfo {
  BrandingImageUrl: string;
  Flags: {[key: number]: string} | null;
}

export interface TeamInfo {
  TeamName: string;
  TeamDisplayName: string;
  BrandingImageUrl: string;
  RedirectUrl: string;
}

export interface SSODomainLoginInfo {
  TeamInfo: Array<TeamInfo | null> | null;
  Flags: {[key: number]: string} | null;
}

export interface CompleteSignupParams {
  AcctId: string;
  AuthTokenId: string;
  AuthToken: string;
  Debug: string;
  GoogleAuthEnforced: boolean;
  GoogleAuthUrl: string;
  HasSetPassword: boolean;
  OrgId: string;
  Dest: string;
  FrontendHost: string;
}

// Wire representation of a single highlight.  See comments in highlights.go about a
// possible lazy evaluation "language" for fields of the form @method(arg[,arg...]).
// In particular, @date and @msg are handled in this file.
export interface Highlight {
  Id: string;
  LastMod: number;
  Creator: string;
  Created: number;
  Text: string;
  Image: string;
  NoteId: string;
  Actions: Array<sharedapi.Action | null> | null;
  DevTools: sharedapi.DevToolsMode;
  SentIntegrations: {[key: string]: string} | null;
}

export interface Note {
  Id: string;
  Created: number;
  Creator: string;
  IndivId: string;
  UserId: string;
  SessionId: string;
  PageId: string;
  PageStart: number;
  When: number;
  AbsTime: number;
  Text: string;
  Link: string;
  ShareLink: string;
  SessionOrClipTime: number;
  IsClip: boolean;
  UserEmail: string;
  UserDisplayName: string;
  Actions: Array<sharedapi.Action | null> | null;
  DevTools: sharedapi.DevToolsMode;
  SentNotes: {[key: string]: string} | null;
}

export interface NewHighlightResponse {
  BroadcastErrors: string[] | null;
  Note: Note | null;
}

export interface Highlights {
  Seats: string[] | null;
  Highlights: Array<Highlight | null> | null;
  PreviousHighwater: number;
  Cursor: string;
  HasMore: boolean;
  ActiveIntegrations: {[key: string]: string} | null;
}

export interface NoteDescriptionReq {
  Note: Note | null;
  Highlight: Highlight | null;
}

export interface NoteDescriptionItem {
  Name: string;
  Value: string;
}

export interface NoteDescriptionRsp {
  Items: Array<NoteDescriptionItem | null> | null;
}
